export default {
  heading: "Агенция за счетоводни услуги",
  published: "Публикувано на",
  zero_posts: "Все още няма добавени блог-постове",
  menu_btns: {
    welcome: "Начало",
    services: "Услуги",
    accounting: "Счетоводство",
    social_services: "Социални Услуги",
    about_us: "За нас",
    price_list: "Ценоразпис",
    promotions: "Промоции",
    promotion_accounting: "Промоция - Счетоводство",
    promotion_services: "Промоция - Услуги",
    forms: "Формуляри",
    contacts: "Контакти",
    blog: "Блог",
  },
  routes: {
    welcome: {
      intro:
        "е лицензиран счетоводен офис във Великобритания. Ние сме официално регистрирани като агент към данъчна служба и митници в Обединеното Кралство – HMRC. Обект сме на Anti Money Laundring Supervision, притежаваме Professional Indemnity Insurance, както и сме регистрирани към Information Commissioner’s Office (ICO), отговарящ за защита на личните данните.",
      heading: "Какво предлагаме?",
      p1:
        "Като лицензиран счетоводител, ние Ви представляваме пред данъчна служба – Великобритания във връзка с Вашите данъчни дела.",
      p2:
        "Притежаваме два офиса – DoKument и Biurokrat, където предлагаме следните услуги:",
      p3:
        "В офиса ни DoKument, предоставяме пълен спектър от счетоводни услуги, както за самоосигуряващи се физически лица – self employed / sole traders, така и за корпоративни дружества - Limited Companies. Пълния пакет на услугите ни, можете да откриете ",
      p4:
        "В офиса ни Biurokrat, предоставяме пълен спектър от социални услуги – преводи на български и полски език от лицензирани преводачи, помощ за кандидастване на социални помощи във Великобритания, детски надбавки, връщане на надвзети данъци и осигуровки, майчинство и други. Пълен пакет на услугите ни, можете да видите ",
      p5:
        "В многогодишната ни практика във Великобритания, ние сме успяли да се докажем като специалисти, както и да създадем добри взаимоотношения с клиентите, да отговаряме на запитванията в най-кратък срок. Зад гърба си имаме стотици спечелени обжалвания, срещу глоби наложени от данъчното. Спазвайки законовите разпоредби, нашият стремеж е да осигурим най-оптималното решение за бизнеса ви, и неговото развитие. Ние разглеждаме случая на всеки клиент строго индивидуално, и опита ни е помогнал да комуникираме с клиента на разбираем за двете страни, счетоводен език. Това са предпоставки да разполагаме с богато портфолио от клиенти.",
      p6:
        "За да стимулираме редовните ни и доволни клиенти, ние сме разработили промоционална програма ‚Препоръчай на приятел‘, чиито условия можете да намерите ",
      conclusion: "Стотици бизнеси са ни се доверили! Доверете ни се и Вие!",
      span_here: "тук",
      footer: {
        office: "Офис",
        open_hours: "Работно време:",
      },
    },
    accounting: {
      heading: "Счетоводни услуги",
      top: {
        limited_companies: {
          vat_returns: "(ДДС декларации)",
          ltd: "Регистриране на ООД",
        },
        solo_trader: {
          register: "Регистрация като самоосигуряващо лице",
          decl: "Годишна Данъчна декларация",
          vat: "(ДДС декларация)",
        },
        insurance: {
          heading: "Бизнес застраховки",
          importance:
            "Изключително важно е да имате бизнес застраховка, за да имате покритие, в случай, че някой клиент не е доволен от Вашите услуги и заведе иск за щети.",
          employer:
            "Ако сте работодател, имате законно задължение да имате застраховка Трудова отговорност.",
          responsible: "Не подценявайте тези отговорности!",
        },
      },
      bottom: [
        {
          heading:
            "Разликите между Едноличен търговец (sole Trader) и Дружество с ограничена отговорност (Limited Company)",
          content:
            "Вижте нашите дефиниции, за сравнение на предимствата и недостатъците и да разберете коя бизнес структура най-добре отговаря на вашите нужди. Всеки бизнес - без значение колко е голям или малък - трябва да има правна структура. Във Великобритания около 3,3 милиона работят като еднолични търговци, и 1,6 милиона работещи като LTD. Каква е разликата между двете? И което би било най-добре за вашия бизнес?",
        },
        {
          heading: "Едноличен търговец (self-employed)",
          content:
            "Едноличен търговец по същество е самостоятелно заето лице, което е едноличен собственик на бизнес си. Това е най-простата бизнес структура - което я прави и най-популярната. Регистрацията за данъчни цели е лесна и праволинейна.",
        },
        {
          heading: "Дружество с ограничена отговорност (LTD)",
          content:
            "Дружество с ограничена отговорност е вид бизнес структура, която има своя собствена правна идентичност, отделно от своите собственици (акционери) и неговите ръководители (директори). Това остава така дори и ако то е управлявано от един човек, в качеството на акционер и директор. Едноличен търговец или дружество с ограничена отговорност? Всяка структура има свойте предимства и недостатъци, така че нека да погледнем по-отблизо опцията за едноличен търговец",
        },
        {
          heading: "Едноличен търговец - предимства",
          content:
            "Лесно е да се създаде и сравнително малко бумащина, необходимо данъчно преключване веднъж годишно. По-голяма поверителност, отколкото при дружество с ограничена отговорност, чийто данни могат да бъдат видени чрез Companies House.",
        },
        {
          heading: "Едноличен търговец - недостатъци",
          content:
            "Едноличните търговци носят неограничена отговорност, тъй като те не се разглежда като отделна правна единица по законите във Великобритания. Това означава, че ако бизнесът изпадне в задлъжнялост, собственика на фирмата е лично отговорен. Така, едноличните търговци могат да загубят личните си активи, ако нещата се объркат. Банково финансиране може да се окаже трудно, тъй като банките и други инвеститори предпочитат дружества с ограничена отговорност. Това ограничава възможностите за разширяване на едноличните търговци. Данъчните ставки за едноличните търговци, не винаги са щедри, така както те са за дружества с ограничена отговорност. Когато стигнете до определено ниво на печалба, става нерентабилно да останете едноличен търговец. И така, какво ползи и недостатъци се учредяват дружество с ограничена донесе?",
        },
        {
          heading: "Предимства на дружеството с ограничена отговорност",
          content:
            "За разлика от едноличния търговец дружеството с ограничена отговорност има предимството на ограничена отговорност, защото има правно разграничение между собственика на дружеството и неговите действия. Това означава, че личните активи не са изложени на опасност от загуба, а само това което сте вложили в дружеството. Най-общо казано, дружества та с ограничена отговорност са по-данъчно ефективни, отколкото едноличните търговци. Към даденият момент данъчните ставки за облагане на печалбите са по-ниски за дружествата с ограничена отговорност отколкото са за едноличните търговци. В допълнение към това, дружествата с ограничена отговорност имат възможност да изписват по широк спектър от  разходи, което намалява печалбата и съответно дължимите данъци. След като сте регистрирали името на дружеството с ограничена отговорност никой друг не може да го използва.",
        },
        {
          heading: "Недостатъци на дружеството с ограничена отговорност",
          content:
            "Директорът на дружеството с ограничени отговорности има правни задължения (Director’s Fiduciary Responsibilities), които трябва стриктно да изпълнява, това от своя страна изисква време и внимание. Отчетите и декларациите, които трябва да бъдат подавани към данъчната служба са значително по-сложни и многобройни, което изисква или директорът да отдели повече време или да наеме счетоводител, което предизвиква допълнителни разходи. При създаването, при пускането на отчетите и при закриването на дружество с ограничена отговорност има административни такси, които се плащат на Companies House. Подробности за директорите и приходите на компанията ви е необходимо да бъде показани публично. Този вид на прозрачност не се харесва на всеки. В крайна сметка е много важно да се претеглят разликите между едноличен търговец и дружество с ограничена отговорност, изборът на структура може да окаже влияние върху всичко от печалбата до бумащината.",
        },
      ],
      footer:
        "Не бързайте да взимате решение, консултирайте се, защото всеки бизнес е индивидуален. Направете информиран избор, за да сте сигурни, че от самото начало сте положили правилните основи.",
    },
    services: {
      heading: "Други социални услуги",
      paragraphs: [
        {
          heading: "Записване на интервю за National insurance number",
          content:
            "Националният осигурителен номер (NINo) във Великобритания е абсолютно необходим и важен - ако търсите работа, започнете работа или започнете бизнес. Националният  осигурителен номер (NINo) е номерът, под който се записват всичките Ви данъци и осигурителни вноски. Ние ще запишем дата и час за издаване на NINo в най-близкият Jobcentre.",
        },
        {
          heading: "Възстановяване на надвзети данъци и осигуровки",
          content:
            "Ако сте работили на неправилен данъчен код или не сте работили цяла данъчна година, както и при напускане на UK вероятността да имате данъци за връщане е голяма. Свържете се с нас за безплатна калкулация.",
        },
        {
          heading: "Държавно майчинство (Maternity allowance)",
          content:
            "Тези от вас, които нямат право на майчинство от работодателят, могат да кандидастват за майчинство от държавата. Свържете се с нас за безплатна консултация.",
        },
        {
          heading:
            "Детски (child benefit) и Социални помощи за лица с ниски доходи (Universal credit)",
          content:
            "Ако работите в UK и имате деца или доходите Ви са ниски има социални помощи за който може да кандидатствате. Свържете се с нас, за да ви консултираме, какви помощи се предлагат в района в който живеете.",
        },
      ],
    },
    pricelist: {
      headings: ["Описание", "Цена"],
      rows: [
        [
          "Регистрация на Limited Complany - включва PAYE, VAT регистрация и държавна такса",
          "£95.00",
        ],
        [
          "Регистрация на Limited Complany - включва PAYE, VAT регистрация, държавна такса и бизнес банкова сметка",
          "£135.00",
        ],
        [
          "Годишно осчетоводяване на сметките на компании, corporation taxt return & end year accounts от £600.00/£50.00(месец)",
          "@",
        ],
        [
          "Изготвяне на ведомсти на заплати(payslips), цена на работник за година е от £60.00/£5.00(месец)",
          "@",
        ],
        [
          "ДДС декларации(VAT returns) - £240.00 на година /£60.00 на тримесечие /£20.00 на месец",
          "@",
        ],
        [
          "Годишна декларация на самоусигуряващи се лица - self assessment tax return",
          "£100.00",
        ],
        ["Регистрация на самоосигуряващи се лица - Self Employed", "£35.00"],
        ["Регистрация по строителна схема - CIS", "£20.00"],
        [
          "Откриване на бизнес банкова сметка - Business Bank Account",
          "£60.00",
        ],
        [
          "Бизнес застраховка - Public & Employers liability insurance package",
          "£30.00",
        ],
        ["Кандидатстване за Bounce Bank Loan", "£50.00"],
        ["Universal credit", "£80.00"],
        [
          "P85 / P38 (Възстановяване на надвзети данъци) от £15.00 до £150.00",
          "10.00%",
        ],
        ["Child benefit(Детски надбавки)", "@"],
        ["Деца, родени във Великобритания *", "£30.00"],
        ["Деца, родени извън Великобритания *", "£50.00"],
        ["Деца, родени и живеещи в друга европейска държава *", "£70.00"],
        ["Възстановяване на изгубен National Insurance Number", "£30.00"],
        ["Създаване на Personal Tax Account", "£20.00"],
        ["Апликация за Pension Credit *", "£80.00"],
        ["Корекция на грешен Tax Code", "£30.00"],
        ["Апликация за държавно майчинство - Maternity Allowance", "£50.00"],
      ],
      extra_tax: "* Има допълнителна такста за пощенски разходи",
      price_avarage:
        "Цените са ориентировъчни и подлежат на промяна според конкретния случай!",
    },
    contacts: {
      left_side: {
        title: "Свържете се с нас",
        labels: {
          name: "Име",
          email: "Електронна поща",
          phone: "Телефон",
          message: "Съобщение",
        },
        btn_submit: "Изпрати",
      },
      right_side: {
        title: "Имате нужда от помощ?",
        title_secondary: "Ние винаги сме готови да ви помогнем.",
        text:
          "Изпратете ни запитване директно чрез попълване на този формуляр лесно, бързо и удобно. Моля въвеждайте данните си коректно, за да можем след това да се свържим с вас на пощата, която сте въвели.",
        office: "Офис",
        address: "Адрес",
        email: "Електронна поща",
        phone: "Телефон",
        mobile_phone: "Мобилен телефон",
      },
      success_msg:
        "Благодаря, че се свързахте с нас! Ще се свържем с вас скоро!",
    },
    promotions: {
      accounting: {
        heading_1: "ПРОМОЦИОНАЛНА ПРОГРАМА",
        heading_2: "„ПРЕПОРЪЧАЙ НА ПРИЯТЕЛ“",
        intro: {
          p1: "Имате приятел или колега, който се нуждае от счетоводни услуги?",
          p2: "Доволни сте от нас и искате да ни препоръчате?",
          p3: "Специално за вас сме разработили промоционална програма",
        },
        container_1: {
          heading: "Какво трябва да направите",
          p1:
            "Изпратете ни имейл с контактите на вашият приятел или колега – име, телефонен номер, имейл.",
          p2:
            "Ако лицето не желае да му се предоставят контактите, то дайте контактите на DoKument, и помолете клиента да назове вашите имена.",
        },
        container_2: {
          heading: "Какво ще получите",
          p1:
            "За препоръка към бъдещ клиент – self employed / sole trader, ще получите gift card на стойност £10.00, която можете да използвате в над 50 магазина в Обединеното Кралство. Наградата ще получите, след като клиента който сте препоръчали, направи плащане към нас.",
          p2:
            "За препоръка към бъдещ клиент с Limited Company – получавате gift card на стойност £50.00, която можете да използвате в над 50 магазина в Обединеното Кралство. Наградата ще бъде получена, след като клиента на който сте ни препоръчали, направи 3 месечни плащания към нас, на база годишен платежен план.",
        },
        container_3: {
          heading: "Правила и условия",
          p1: "Промоцията е валидна само за клиенти които ни плащат редовно.",
          p2:
            "Промоцията не е валидна за тези от вас които вече не работят с нас.",
          p3:
            "Промоцията е валидна само за бъдещи клиенти, които ще използват счетоводни услуги-self employed/sole traders или Limited Companies.",
          p4:
            "Промоцията важи само за препоръка към бъдещ клиент, който за пръв път ще използва наша услуга.",
        },
        terms: {
          p1:
            "Промоционалната програма е валидна от 17.08.2020г до 31.12.2020г включително**",
          p2:
            "** В случай на злоупотреби, запазваме правото си да оттеглим промоцията по всяко време, без предупреждение!",
        },
      },
      services: {
        heading_1: "ПРОМОЦИОНАЛНА ПРОГРАМА",
        heading_2: "„РЕДОВНИ КЛИЕНТИ“",
        intro: {
          p1: "Имате нужда да използвате нашите услуги?",
          p2: "Останали сте доволни и имате нужда от допълнителна помощ?",
          p3: "Специално за вас сме разработили промоционална програма!",
        },
        container_1: {
          heading: "В какво се състои програмата",
          p1:
            "Всеки клиент използващ социалните услуги които предлагаме, може да се включи в програмата.",
          p2:
            "Програмата важи пакетно за едно семейство, живеещо на един и същи адрес.",
        },
        container_2: {
          heading: "Какво ще получите",
          p1:
            "Ще получите gift card, която можете да използвате за покупки в над 50 магазина в Обединеното Кралство.",
          list: {
            heading:
              "Наградата се получава в края на месеца, в зависимост от месечната сума която е заплатило семеството към нас, или както следва:",
            items: {
              p1:
                "При месечни плащания към нас на стойност между £50 - £70 - получавате gift card за £5.00",
              p2:
                "При месечни плащания към нас на стойност между £70 - £120 - получавате gift card за £10.00",
              p3:
                "При месечни плащания към нас на стойност над £120 - получавате gift card за £15.00",
            },
            conclusion:
              "Пощенските разходи, които ни плащате, НЕ се начисляват към плащанията за услуги!",
          },
        },
        container_3: {
          heading: "Правила и условия",
          p1: "Промоцията е валидна само за клиенти които ни плащат редовно.",
          p2:
            "Промоцията не е валидна за тези от вас които вече не работят с нас.",
          p3: "Промоцията е валидна само за един ваучер на семейство.",
          p4:
            "Промоцията е валидна само за клиенти, които ще използват социални услуги-социални помощи, държавно майчинство, детски, услуга - връщане на надвзет данък, и васички други БЕЗ счетоводство на самоосигуряваши се лица и Limited Companies.",
          conclusion:
            "Промоционалната програма е валидна от 01.10.2020г до 31.12.2020г включително**!",
        },
        footer:
          "** В случай на злоупотреби, запазваме правото си да оттеглим промоцията по всяко време, без предупреждение!",
      },
    },
    forms: {
      download_file: "Изтегли файл",
      dokument: {
        heading:
          "Формуляри и бланки за счетоводни услуги, които извършваме в офис DoKument",
        p1:
          "Можете да използвате този формуляр, за отчитане на бизнес милите Ви:",
        p2:
          "За отчитане на доходи получени в кеш, можете да използвате този формуляр:",
        p3:
          "За назначаване на работник/директор на работа, използвайте този формуляр:",
        p4:
          "За отчитане плащанията към субконтракторите, използвайте този формуляр:",
        p5: "За регистрация като self employed, попълнете следната бланка:",
        p6: "За регистрация на Limited Company, попълнете следната бланка:",
      },
      biurokrat: {
        heading: "Бланки за социални услуги, които извършваме в офис Biurokrat",
        p1:
          "За кандидатстване за осигурителен номер, молим използвайте следната бланка:",

        p2:
          "За кандидатстване за Universal Credit, молим използвайте следната бланка:",

        p3:
          "За кандидатстване за инвалидна помощ, молим използвайте следната бланка:",

        p4:
          "За изискване на справка за пенсионни осигуровки, молим използвайте следната бланка:",

        p5:
          "За кандидатстване за детски надбавки, молим използвайте следната бланка:",

        p6:
          "За помощ при записване на дете/деца в училище, молим използвайте следната бланка:",

        p7:
          "За кандидастване за сертификат - доказателство за стаж придобит в UK, и/или признаване на здравни осигуровки, молим използвайте следната бланка: ",
      },
    },
  },
  monday: "Понеделник:",
  tuesday: "Вторник:",
  wednesday: "Сряда:",
  thursday: "Четвъртък:",
  friday: "Петък:",
  saturday: "Събота:",
};
